import { Context, CustomQuery } from '@vue-storefront/core';
import { ApiResult } from '../../types';
// eslint-disable-next-line @typescript-eslint/no-unused-vars
export default async function customClearCart({ client, config }: Context, parms: CustomQuery): Promise<ApiResult> {

  const url = new URL('/mall/cart/clear', config.api.url);
  // Use axios to send a GET request
  const { data } = await client.post(url.href);

  // Return data from the API
  return data;
}
